import Backbone from 'backbone';
import { View } from 'backbone.marionette';
import _ from 'underscore';

import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';

import ReloadViewModule from '../../../services/ReloadViewModule';
import OrderDeviceSectionView from '../../../views/OrderDeviceSectionView';
import SaveCustomerOrderDevices from '../../../services/SaveCustomerOrderDevices';

import tmplMaintenanceFormView from './MaintenanceFormView.hbs';

const MaintenanceFormView = View.extend({
  template: tmplMaintenanceFormView,

  className: 'maintenance-form-view',

  ui: {
    descriptionSection: '.description-section',
    deviceTypeSection: '.device-type-section',
    additionalServicesSection: '.additional-services-section',
    devicesAlert: '.no-devices-error'
  },

  regions: {
    descriptionSection: '@ui.descriptionSection',
    deviceTypeSection: '@ui.deviceTypeSection',
    additionalServicesSection: '@ui.additionalServicesSection'
  },

  onRender() {
    const orderType = this.model.get('orderDetails').orderTypeId;
    const lineItemGroups = _.groupBy(this.model.get('lineItems'), 'panel');
    const deviceTypes = lineItemGroups['Type of Device Requiring Maintenance'];
    const additionalServices = lineItemGroups['Additional Maintenance Services'];

    this.showChildView(
      'descriptionSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          title: 'Device Information',
          type: 'description',
          id: 'description',
          contract: 'Maintenance'
        })
      })
    );

    this.showChildView(
      'deviceTypeSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: deviceTypes,
          title: 'Type of Device Requiring Maintenance',
          orderType,
          id: 'device'
        })
      })
    );
    this.showChildView(
      'additionalServicesSection',
      new OrderDeviceSectionView({
        model: new Backbone.Model({
          lineItems: additionalServices,
          title: 'Additional Maintenance Services',
          orderType,
          id: 'service'
        })
      })
    );
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occurred while saving devices for this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  },

  async validate() {
    const deviceTypeColl = await this.getChildView('deviceTypeSection').getDeviceData();
    const additionalServiceColl = await this.getChildView('additionalServicesSection').getDeviceData();
    let isValid = true;
    if (
      !deviceTypeColl.numDevicesForMaintenance &&
      !additionalServiceColl.numOnsiteTechnicians &&
      !additionalServiceColl.numFirmwareSoftwareUpdates
    ) {
      isValid = false;
      this.ui.devicesAlert.show();
    }
    isValid ? this.trigger('no:errors') : this.trigger('has:errors');
    return isValid;
  },

  async onSave() {
    this.ui.devicesAlert.hide();
    this.trigger('no:errors');
    const deviceTypeColl = await this.getChildView('deviceTypeSection').getDeviceData();
    const additionalServiceColl = await this.getChildView('additionalServicesSection').getDeviceData();
    const numDevicesForMaintenance = deviceTypeColl.numDevicesForMaintenance;
    const numOnsiteTechnicians = additionalServiceColl.numOnsiteTechnicians;
    const numFirmwareSoftwareUpdates = additionalServiceColl.numFirmwareSoftwareUpdates;
    const totalOrderQuantity = numDevicesForMaintenance + numOnsiteTechnicians + numFirmwareSoftwareUpdates;
    const orderFormData = {
      totalOrderQuantity,
      numDevicesForMaintenance,
      numFirmwareSoftwareUpdates,
      numOnsiteTechnicians
    };
    const devicesFormData = deviceTypeColl?.changedItems?.concat(additionalServiceColl?.changedItems || []) || [];

    const formData = {
      devicesFormData,
      orderFormData,
      orderId: this.model.get('orderDetails').orderId,
      orderTypeId: this.model.get('orderDetails').orderTypeId
    };

    this.showSaveSuccess();

    try {
      await SaveCustomerOrderDevices(formData);
      await ReloadViewModule.reload();
      this.showSaveSuccess();
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  }
});

export default MaintenanceFormView;
